import { EventEmitter } from 'fbemitter';

class GeckoModalService {
  static emitter;
  get emitter() {
    return GeckoModalService.emitter;
  }
  set emitter(value) {
    GeckoModalService.emitter = value;
  }

  params = {
    size: 'lg',
    backdrop: true,
    keyboard: true,
  };

  constructor() {
    // Create modal event emitter (if not already created)
    if (!this.emitter) this.emitter = new EventEmitter();
  }

  open(component, params) {
    return new Promise((resolve, reject) => {
      this.emitter.emit(
        'open',
        component,
        Object.assign({}, this.params, params)
      );

      this.emitter.once('dismiss', (data) => resolve());
      this.emitter.once('close', (data) => resolve(data));
    });
  }

  close(data) {
    return this.emitter.emit('close', data);
  }
}

export default GeckoModalService;
